import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=12081201&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=js&"
export * from "./deal.vue?vue&type=script&lang=js&"
import style0 from "./deal.vue?vue&type=style&index=0&id=12081201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12081201",
  null
  
)

export default component.exports